import * as types from "../actions/types";



const initialState = {
  list: [],
  current: null,
  speciality: [],
  organizations: [],
  students: [],
  loading: false
};


export default function profotbor (state = initialState, action) {
  switch (action.type) {
    case types.SET_PROFOTBOR_CURRENT:
      return {
        ...state,
        current: action.payload,
      };
    case types.SET_PROFOTBOR_LIST:
      return {
        ...state,
        list: action.payload,
      };
    case types.SET_PROFOTBOR_SPECIALITY:
      return {
        ...state,
        speciality: action.payload,
      };
    case types.SET_PROFOTBOR_ORGANIZATION:
      return {
        ...state,
        organizations: action.payload,
      };
    case types.SET_PROFOTBOR_STUDENTS:
      return {
        ...state,
        students: action.payload,
      };
    case types.SET_PROFOTBOR_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
}